import React from 'react';
import { FaArrowRight, FaMotorcycle, FaStore, FaUser } from 'react-icons/fa';

const CARDS = [
  {
    icon: FaUser,
    title: 'Particuliers',
    text: "Envoyez un colis en quelques minutes, sans créer de compte. Devis instantané et suivi en temps réel.",
    cta: 'Expédier un colis',
    href: '/quick-delivery',
  },
  {
    icon: FaStore,
    title: 'Marchands & e-commerce',
    text: "Confiez-nous votre logistique : catalogue, commandes, paiement à la livraison, et intégrez la livraison OuiGoo à votre boutique ou plateforme.",
    cta: 'Découvrir les solutions',
    href: '/marchands',
  },
  {
    icon: FaMotorcycle,
    title: 'Livreurs & partenaires',
    text: "Rejoignez le réseau OuiGoo, recevez des courses près de chez vous et développez vos revenus.",
    cta: 'Devenir livreur',
    href: '/become-partner',
  },
];

const Audiences = () => {
  return (
    <section id="pour-qui" className="py-16 bg-white">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2">
          Une plateforme, pour chacun de vos besoins
        </h2>
        <p className="section-description">
          Que vous envoyiez un colis, gériez une boutique ou rouliez pour livrer, OuiGoo est fait pour vous.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {CARDS.map(({ icon: Icon, title, text, cta, href, external }) => (
            <a
              key={title}
              href={href}
              {...(external ? { rel: 'noopener noreferrer' } : {})}
              className="group flex flex-col bg-white p-8 rounded-lg service-card text-left border border-gray-100 hover:border-primary-custom/30"
            >
              <div className="service-icon w-12 h-12 rounded-xl bg-orange-50 text-primary-custom flex items-center justify-center mb-6">
                <Icon className="w-5 h-5" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-800">{title}</h3>
              <p className="text-gray-600 font-inter flex-1">{text}</p>
              <span className="mt-5 inline-flex items-center gap-2 font-semibold text-primary-custom group-hover:gap-3 transition-all">
                {cta} <FaArrowRight className="w-3.5 h-3.5" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Audiences;
